import { API_BASEURL } from '@/utils/config/env';
import Axios from 'axios';
import { getCookie } from 'cookies-next';
import { gethandshakeApiRoute, getServerHandshake } from './global/handshake';

const axios = Axios.create({
  baseURL: API_BASEURL,
  maxBodyLength: Infinity,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});
let isHandshakeFetching = false;

axios.interceptors.request.use(
  async (config) => {
    let handshake;

    if (typeof window !== 'undefined') {
      const locale = getCookie('NEXT_LOCALE') || 'ar';
      handshake = getCookie(`phst_${locale}`);
    } else {
      handshake = await getServerHandshake();
    }

    // handle expiration of handshake and deleted from cookies
    if (typeof window !== 'undefined' && !handshake && !isHandshakeFetching) {
      isHandshakeFetching = true;
      const handshakeRes = await gethandshakeApiRoute();
      handshake = handshakeRes?.data;
      isHandshakeFetching = false;
    }

    const isV1 = config?.baseURL?.includes('v1');

    if (handshake && isV1) {
      config.headers['Authorization'] = `Bearer ${handshake}`;
    }
    return config;
  },
  (err) => Promise.reject('Error in axios config', err)
);

axios.interceptors.response.use(
  (res) => {
    return Promise.resolve({
      data: res.data,
      error: null,
      status: res.status,
      // headers: res.headers,
    });
  },
  (error) => {
    if (error.response) {
      console.log(
        '❌❌❌ api response error________________________ :',
        error.response.status,
        '--->',
        error.config
      );
      return Promise.reject({
        data: null,
        error: error.response?.data,
        status: error.response.status,
      });
    } else if (error.request) {
      console.log(
        '❌❌❌ api request error________________________ :',
        error.request.status,
        ' ---> ',
        error.config
      );
      return Promise.reject({
        data: null,
        error: error.request?.data,
        status: error.request.status,
      });
    } else {
      console.log(
        '❌❌❌ api request error________________________ :',
        500,
        '--->',
        error
      );
      return Promise.reject({
        data: null,
        error: error,
        status: 500,
      });
    }
  }
);

export default axios;
